export const CATEGORIES = {
  ALL: "all",
}
